<template>
  <div>
    <Movementmenu_govem />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        :title="'กำหนดการปฏิทินการย้าย' + label('ข้าราชการครู')"
        class="px-5 py-3"
      >
        <v-card class="mb-4 pa-2">
          <v-row>
            <v-col cols="12" md="12" class="text-right">
              <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item color="grey lighten-1" fill-dot left small>
                  <v-card>
                    <v-card-title class="grey lighten-1 justify-end">
                      <h2 class="mr-4 white--text font-weight-light">
                        กำหนดการ
                        <span class="red--text">
                          {{ label("ข้าราชการครู") }}</span
                        >
                      </h2>
                      <v-icon dark size="42">
                        mdi-calendar
                      </v-icon>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <Period_govem />
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>

                <v-timeline-item color="purple lighten-2" fill-dot right>
                  <v-card>
                    <v-card-title class="purple lighten-2">
                      <v-icon dark size="42" class="mr-4">
                        mdi-calendar
                      </v-icon>
                      <h2 class="white--text font-weight-light">
                        วิทยาลัย สำรวจตำแหน่งว่าง
                      </h2>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="12">
                          <PeriodCollege_govem />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>

                <v-timeline-item color="purple lighten-2" fill-dot right>
                  <v-card>
                    <v-card-title class="purple lighten-2">
                      <v-icon dark size="42" class="mr-4">
                        mdi-calendar
                      </v-icon>
                      <h2 class="white--text font-weight-light">
                        วิทยาลัย รวบรวมคำร้องขอย้าย{{ label("ข้าราชการครู") }}
                      </h2>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="12">
                          <PeriodCollegeRequest_govem />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>

                

                <v-timeline-item color="purple lighten-2" fill-dot right>
                  <v-card>
                    <v-card-title class="purple lighten-2">
                      <v-icon dark size="42" class="mr-4">
                        mdi-calendar
                      </v-icon>
                      <h2 class="white--text font-weight-light">
                        วิทยาลัยปลายทาง (รับรายงานตัว)
                      </h2>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="12">
                          <PeriodCollegeGovemReport />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-card>
      </base-material-card>
    </v-container>
  </div>
</template>

<script>
import Period_govem from "../../../components/admin/period_govem.vue";
import Movementmenu_govem from "../../../components/admin/movementmenu_govem.vue";
import PeriodCollege_govem from "../../../components/admin/periodCollege_govem.vue";
import PeriodCollegeRequest_govem from "../../../components/admin/periodCollegeRequest_govem.vue";
import PeriodCollegediscussGovem from "../../../components/admin/periodCollegediscussGovem.vue";
import PeriodCollegeGovemReport from "../../../components/admin/periodCollegeGovemReport.vue";

export default {
  name: "HRvecTransferTeachers",
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      user: []
    };
  },

  async mounted() {
    await this.userQueryAll();
  },
  methods: {
    async userQueryAll() {
      let result;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user = result.data;
    },

    label(text) {
      return this.user.userauthority_govem === "1"
        ? text.replace(/ข้าราชการครู/g, "พนักงานราชการ")
        : text;
    }
  },
  components: {
    Period_govem,
    Movementmenu_govem,
    PeriodCollege_govem,
    PeriodCollegeRequest_govem,
    PeriodCollegediscussGovem,
    PeriodCollegeGovemReport
  }
};
</script>

<style lang="scss" scoped></style>
